import { makeAutoObservable } from 'mobx';

import {
  toFeedDensity,
  type FeedDensity,
} from '@/features/action-cards-view/feed/feedDensity';
import { trackEvent } from '@/utils/analytics';
import { getDeviceSetting, setDeviceSetting } from '@/utils/localStorage';

const FEED_DENSITY_KEY = 'feed-density';

class FeedDensityStore {
  density: FeedDensity = toFeedDensity(getDeviceSetting(FEED_DENSITY_KEY));

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDensity(density: FeedDensity) {
    if (density === this.density) return;

    const previousDensity = this.density;
    this.density = density;
    setDeviceSetting(FEED_DENSITY_KEY, density);
    trackEvent('FEED_DENSITY_CHANGED', {
      density,
      previous_density: previousDensity,
    });
  }
}

export const feedDensityStore = new FeedDensityStore();
